<template>
  <div id="Debtor" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="فرم برداشت وجه"
      description="از طریق این فرم می‌توانید درخواست برداشت وجه خود را اعلام کنید"
      :show-back="true"
    >
      <div class="Debtor-form-vertical py-3 px-0">
        <!-- بخش ۱: حساب مبدأ -->
        <div class="Debtor-section">
          <div class="Debtor-section-title">حساب مبدأ</div>
          <div class="Debtor-field">
            <label class="Debtor-label">انتخاب حساب</label>
            <select
              v-if="IsLoad"
              name="cmbTaahodat"
              id="cmbTaahodat"
              class="form-control Pointer"
              v-model="Resultcmb"
              @change="CheckIfDelayed(Resultcmb)"
            >
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel"
                :key="item.id"
                :value="item"
              >
                <span>{{ item.vcodeDesNo }} </span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="Debtor-field">
            <span class="text-muted"
              >مبلغ قابل برداشت:
              {{
                Resultcmb &&
                !isNaN(Resultcmb.ghabelBardasht + Resultcmb.sumMabTaeedNaShode)
                  ? $Comma3ragham(
                      Resultcmb.ghabelBardasht + Resultcmb.sumMabTaeedNaShode,
                    )
                  : ""
              }}</span
            >
          </div>
        </div>
        <!-- بخش ۲: اطلاعات مقصد -->
        <article v-if="$session.get('CustCode') != 801">
          <div class="Debtor-section">
            <div class="Debtor-section-title">اطلاعات مقصد</div>

            <div class="Debtor-field">
              <label class="Debtor-label">روش انتقال</label>
              <div class="radio pr-4">
                <input
                  v-if="
                    $session.get('CustCode') != 561 &&
                    $session.get('CustCode') != 866 &&
                    $session.get('CustCode') != 948 &&
                    $session.get('CustCode') != 953
                  "
                  label="انتقال به کارت"
                  type="radio"
                  name="NoeEnteghal"
                  value="Card"
                  checked="NoeEnteghal == 'Card'"
                  v-model="NoeEnteghal"
                  @click="ShowList = false"
                />
                <input
                  v-if="$session.get('CustCode') != 934"
                  class="mx-1"
                  label="ساتـــنا"
                  type="radio"
                  name="NoeEnteghal"
                  value="Satna"
                  checked="NoeEnteghal == 'Satna'"
                  v-model="NoeEnteghal"
                  @click="ShowList = false"
                />
                <input
                  v-if="$session.get('CustCode') != 934"
                  label="پایا"
                  type="radio"
                  name="NoeEnteghal"
                  value="Sheba"
                  checked="NoeEnteghal == 'Sheba'"
                  v-model="NoeEnteghal"
                  @click="ShowList = false"
                />
              </div>
            </div>

            <div v-if="NoeEnteghal == 'Card'" class="Debtor-field">
              <label class="Debtor-label">شماره کارت</label>
              <div class="row" dir="ltr">
                <div class="col-3 px-1">
                  <input
                    type="number"
                    class="form-control text-center"
                    id="FirstInput"
                    @input="
                      First4Digit.length >= 4
                        ? ((First4Digit = First4Digit.slice(0, 4)),
                          jumpTo('SecondInput'))
                        : void 0
                    "
                    v-model="First4Digit"
                  />
                </div>
                <div class="col-3 px-1">
                  <input
                    type="number"
                    class="form-control text-center"
                    id="SecondInput"
                    @input="
                      Second4Digit.length >= 4
                        ? ((Second4Digit = Second4Digit.slice(0, 4)),
                          jumpTo('ThirdInput'))
                        : checkBankName()
                    "
                    v-model="Second4Digit"
                  />
                </div>
                <div class="col-3 px-1">
                  <input
                    type="number"
                    class="form-control text-center"
                    id="ThirdInput"
                    @input="
                      Third4Digit.length >= 4
                        ? ((Third4Digit = Third4Digit.slice(0, 4)),
                          jumpTo('lastInput'))
                        : void 0
                    "
                    v-model="Third4Digit"
                  />
                </div>
                <div class="col-3 px-1">
                  <input
                    type="number"
                    class="form-control text-center"
                    id="lastInput"
                    @input="
                      Forth4Digit.length >= 4
                        ? ((Forth4Digit = Forth4Digit.slice(0, 4)),
                          EstelamCart())
                        : void 0
                    "
                    v-model="Forth4Digit"
                  />
                </div>
              </div>
              <div
                class="row mt-2"
                v-if="
                  $session.get('CustCode') == 934 ||
                  $session.get('CustCode') == 8002
                "
              >
                <div class="col-12 d-none" id="Bank">بانک مقصد :</div>
                <div class="col-12 d-none" id="BankName">
                  {{ bankSelected.bankName }}
                </div>
                <div class="col-12 d-none" id="Error">
                  <div
                    class="alert alert-danger font-weight-normal text-center"
                  >
                    امکان انتقال فقط به کارت های با مقصد ملی ، سپه و کشاورزی
                    امکان پذیر می باشد
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <span
                  class="Pointer text-warning small"
                  @click="
                    KEY++;
                    GetDataShebaOrCard();
                    SearchShebaOrCard = '';
                    ShowList = !ShowList;
                  "
                  ><i class="fa fa-list mr-1"></i>لیست کارت های ذخیره شده</span
                >
              </div>
            </div>

            <div
              v-if="NoeEnteghal == 'Sheba' || NoeEnteghal == 'Satna'"
              class="Debtor-field"
            >
              <label class="Debtor-label"
                >شماره شبا
                <span
                  class="text-danger small"
                  v-if="$GetIsEstelamSheba() === 'true'"
                  >(بعد از وارد کردن استعلام
                  <i class="fa fa-search text-primary"></i> را انجام دهید)</span
                ></label
              >
              <div class="row align-items-center" dir="ltr">
                <div class="col-auto d-none d-md-block pr-1">
                  <small style="font-size: 1.4rem">IR</small>
                </div>
                <div class="col">
                  <input
                    type="number"
                    @keypress="
                      ShowEstelam = false;
                      NameSahebHesab = '';
                    "
                    @input="
                      ShebaNo.length > 24
                        ? ((ShebaNo = ShebaNo.slice(0, 24)),
                          jumpTo('NameSahebHesab'))
                        : void 0
                    "
                    class="form-control"
                    v-model="ShebaNo"
                  />
                </div>
                <div class="col-auto d-flex align-items-center pr-0">
                  <i
                    class="fa fa-search text-primary fa-lg Pointer mx-1"
                    :title="'استعلام شماره شبا'"
                    @click="Estelam"
                  ></i>
                  <i
                    class="fa fa-list text-warning fa-lg Pointer mx-1"
                    :title="'لیست شبا های ذخیره شده'"
                    @click="
                      KEY++;
                      GetDataShebaOrCard();
                      SearchShebaOrCard = '';
                      ShowList = !ShowList;
                    "
                  ></i>
                </div>
              </div>
            </div>

            <div
              v-if="ShowList"
              class="Debtor-field BoxList"
              dir="ltr"
              :key="KEY"
            >
              <div class="alert bg-dark text-light text-center py-2 mb-2">
                لیست <span v-if="NoeEnteghal == 'Card'"> کارت های </span
                ><span v-else> شبا های </span> ذخیره شده
              </div>
              <input
                type="text"
                class="form-control text-center mb-2"
                v-model="SearchShebaOrCard"
                :placeholder="
                  NoeEnteghal == 'Card'
                    ? 'جستجو در شماره کارت یا نام صاحب...'
                    : 'جستجو در شماره شبا یا نام صاحب...'
                "
              />
              <div
                class="Debtor-sheba-item border-Sheba mt-1 py-3 px-3"
                v-for="(item, key) in FilteredListShebaOrCard"
                :key="key"
              >
                <div
                  class="d-flex align-items-center justify-content-between w-100"
                >
                  <div class="text-right">
                    <span class="text-warning" v-if="NoeEnteghal != 'Card'">
                      IR
                    </span>
                    <span>{{ item.shebaOrCardNum }}</span>
                    <div class="small text-muted">
                      {{ item.sahebShebaOrCard }}
                    </div>
                  </div>
                  <div class="flex-shrink-0">
                    <span
                      v-if="item.selected != true"
                      class="Pointer mr-2"
                      @click="
                        SelectShebaOrCard(
                          item.id,
                          NoeEnteghal != 'Card' ? true : false,
                        )
                      "
                      title="انتخاب"
                      ><i class="fa fa-check hover-info"></i
                    ></span>
                    <span v-else class="mr-2"
                      ><i class="fa fa-check text-success"></i
                    ></span>
                    <span
                      class="Pointer"
                      @click="RemoveShebeOrCard(item)"
                      title="حذف"
                      ><i class="fa fa-trash hover-danger"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="ShowEstelam"
              class="Debtor-field border rounded p-3"
              :key="KEY"
            >
              <div class="small">
                <strong>شماره حساب:</strong>
                {{ EstelamData.accountNumber }}
              </div>
              <div class="small">
                <strong>مشخصات حساب:</strong>
                {{ EstelamData.accountComment }}
              </div>
              <div class="small">
                <strong>صاحبان حساب:</strong>
                <span v-for="(item, index) in EstelamData.holders" :key="index"
                  ><span v-if="item.firstName != ''"
                    >{{ item.firstName + " " + item.lastName + "," }}
                  </span></span
                >
              </div>
            </div>

            <div class="Debtor-field">
              <label class="Debtor-label">نام صاحب حساب</label>
              <input
                id="NameSahebHesab"
                type="text"
                v-model="NameSahebHesab"
                @keyup="$BlockSuspiciousInput($event, 50)"
                @keypress="$BlockSuspiciousInput($event, 50)"
                class="form-control"
                :disabled="
                  $session.get('CustCode') == 934 || ShowEstelam == true
                "
              />
            </div>

            <div class="Debtor-field">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input InputText"
                  v-model="SaveShebaOrCard"
                  id="SaveShebaOrCard"
                />
                <label
                  class="custom-control-label Pointer"
                  for="SaveShebaOrCard"
                  v-if="NoeEnteghal == 'Card'"
                  >ذخیره اطلاعات کارت</label
                >
                <label
                  class="custom-control-label Pointer"
                  for="SaveShebaOrCard"
                  v-else
                  >ذخیره اطلاعات شبا</label
                >
              </div>
            </div>
          </div>
        </article>

        <!-- بخش ۳: مبلغ -->
        <div class="Debtor-section">
          <div class="Debtor-section-title">مبلغ</div>
          <div class="Debtor-field">
            <label class="Debtor-label">مبلغ برداشت</label>
            <input
              type="text"
              ref="txtMablagh"
              id="txtMablagh"
              tabindex="1"
              class="form-control 3ragham text-center"
              style="font-size: 15px !important"
              v-model="MabBardasht"
              @keyup="$BlockSuspiciousInput($event, 30)"
              @keypress="$BlockSuspiciousInput($event, 30)"
            />
            <div
              class="text-dark font-weight-bold mt-2"
              style="font-size: 14px !important"
            >
              {{ Mab2persian }}
            </div>
          </div>
        </div>

        <!-- توضیحات (اختیاری) -->
        <div v-if="$session.get('CustCode') == 866" class="Debtor-section">
          <div class="Debtor-section-title">توضیحات (اختیاری)</div>
          <div class="Debtor-field">
            <textarea
              class="form-control"
              v-model="Description"
              rows="3"
            ></textarea>
          </div>
        </div>

        <!-- کپچا و دکمه -->
        <div class="Debtor-section">
          <div class="Debtor-field">
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div class="Debtor-field text-center mt-4">
            <button
              v-if="!twoLevel"
              :disabled="!CaptchaValid"
              class="btn btn-danger btn-lg px-5"
              @click="SabtBardasht(TaahodatId)"
            >
              {{ GetMablagh }}
            </button>
            <button
              id="CloseModal"
              class="btn btn-danger w-75 d-none"
              data-dismiss="modal"
            ></button>
          </div>
        </div>

        <!-- دو مرحله‌ای -->
        <div v-if="twoLevel == true" class="Debtor-section">
          <hr class="my-3" />
          <div class="Debtor-field">
            <label class="Debtor-label">رمز پیامک شده را وارد کنید</label>
            <div class="row align-items-end">
              <div class="col">
                <input
                  v-model="twstepCode"
                  type="number"
                  class="form-control text-center"
                />
              </div>
              <div class="col-auto mt-2 mt-md-0">
                <button @click="CheckCode" class="btn btn-success px-4">
                  تایید
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import loading from "../Tools/NetPa/Loading.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import SelectCombo from "@/components/Tools/SelectCombo.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      disable: false,
      listBank: [
        { code: "5892-10", bankName: "بانک سپه" },
        { code: "6037-99", bankName: "بانک ملی ایران" },
        { code: "6037-70", bankName: "بانک کشاورزی" },
        { code: "6392-17", bankName: "بانک کشاورزی" },
      ],
      bankSelected: {},
      isLicenseDebtor: true,
      twstepCode: "",
      twoLevel: false,
      EstelamData: {
        accountNumber: "",
        holders: [{ firstName: "", lastName: "" }],
      },
      tblBankId: null,
      ShowList: false,
      ShowEstelam: false,
      KEY: 0,
      First4Digit: "",
      Second4Digit: "",
      Third4Digit: "",
      Forth4Digit: "",
      MabBardasht: "",
      NameSahebHesab: "",
      BankName: "",
      ShebaNo: null,
      CardNo: null,
      withdrawalIfLoanIsDelayed: false,
      selectKey: -1,
      NoeEnteghal: "Card",
      DataAxios: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EnteghalVajh",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      IsLoad: false,
      Resultcmb: null,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "عنوان حساب",
          name: "DesNoe",
        },
        {
          label: "کد حساب",
          name: "VCode",
        },
        {
          label: "مبلغ برداشت",
          name: "Bestan",
        },
        {
          label: "زمان تراکنش",
          name: "ZamanInsert",
        },
        {
          label: "تاریخ سند",
          name: "TarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "CodeRahgiri",
        },
        {
          label: "شرح برداشت",
          name: "SharhSanad",
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      SaveShebaOrCard: false,
      ListSheba: [],
      ListCard: [],
      SearchShebaOrCard: "",
      Description: "",
    };
  },
  components: {
    NetPaListPageCard,
    loading,
    ModalCustom,
    SelectCombo,
    CaptchaBox,
  },
  props: ["TaahodatId", "GhebelBardasht"],
  updated() {
    this.$PutCommatoInput();
  },
  computed: {
    Mab2persian() {
      var Mab = this.MabBardasht.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      return " مبلـغ " + Num2persian(Mab) + " " + this.$GetVahedPool();
    },
    GetMablagh() {
      var Mab = this.MabBardasht.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      return (
        " برداشــت " + this.$Comma3ragham(Mab) + " " + this.$GetVahedPool()
      );
    },
    FilteredListShebaOrCard() {
      const list = this.NoeEnteghal === "Card" ? this.ListCard : this.ListSheba;
      const q = (this.SearchShebaOrCard || "").trim();
      if (!q) return list;
      const lower = q.toLowerCase();
      return list.filter(
        (item) =>
          (item.shebaOrCardNum &&
            item.shebaOrCardNum.toLowerCase().includes(lower)) ||
          (item.sahebShebaOrCard &&
            item.sahebShebaOrCard.toLowerCase().includes(lower)),
      );
    },
  },
  methods: {
    CheckIfDelayed(accountInfo) {
      if (this.$session.get("CustCode") == "948") {
        if (
          this.Resultcmb.withdrawalIfLoanIsDelayed &&
          this.$session.get("moavaghatNoeId")
        ) {
          if (
            this.$session
              .get("moavaghatNoeId")
              .includes(accountInfo.wwwtblNoeId)
          ) {
            this.$mySweetDefault(
              "خطا",
              "این حساب داری اقساط معوقه می‌باشد و امکان برداشت از آن وجود ندارد",
              "error",
              2500,
            );
            this.Resultcmb = -1;
          }
        }
      }
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SabtBardasht(id) {
      //console.log(this.ShebaNo);

      if (this.$session.get("CustCode") != 801) {
        if (this.MabBardasht.replace(/,/g, "").length < 4) {
          this.$mySweetDefault(
            "خطا",
            "مبلغ برداشت نمی تواند کمتر از 10,000 " +
              this.$GetVahedPool() +
              " یا خالی باشد",
            "error",
            2500,
          );
          this.refreshCaptcha();
          return;
        }

        if (this.NoeEnteghal == "Card") {
          if (this.$session.get("CustCode") != 934) {
            this.ShebaNo = "";
          }
          this.CardNo =
            this.First4Digit +
            this.Second4Digit +
            this.Third4Digit +
            this.Forth4Digit;
          if (this.CardNo.length != 16) {
            this.$mySweetDefault(
              "خطا",
              "شماره کارت صحیح نمیباشد",
              "error",
              2500,
            );
            this.refreshCaptcha();
            return;
          }
        } else {
          if (this.$session.get("CustCode") != 934) {
            this.CardNo = "";
          }
          if (this.ShebaNo == null || this.ShebaNo.length != 24) {
            this.$mySweetDefault(
              "خطا",
              "شماره شبا صحیح نمیباشد",
              "error",
              2500,
            );
            this.refreshCaptcha();
            return;
          }
        }
        if (this.NameSahebHesab.length < 1) {
          if (this.$GetIsEstelamSheba() === "true") {
            this.Estelam();
            return;
          }
          this.$mySweetDefault(
            "خطا",
            "نام صاحب حساب وارد نشده است",
            "error",
            2500,
          );
          this.refreshCaptcha();
          return;
        }
      }
      if (this.$session.get("CustCode") == 934 && this.disable == false) {
        this.$mySweetDefault(
          "خطا",
          "استعلام شماره کارت انجام نشده است ، ابتدا شماره کارت را به صورت صحیح وارد کرده و مجدد تلاش کنید",
          "error",
          3000,
        );
        this.refreshCaptcha();
        return;
      }
      if (this.$GetIsEstelamSheba() === "true" && this.ShowEstelam == false) {
        this.$mySweetDefault(
          "خطا",
          "استعلام شماره شبا انجام نشده است ، ابتدا شماره شبا را به صورت صحیح وارد کرده و مجدد تلاش کنید",
          "error",
          3000,
        );
        this.refreshCaptcha();
        return;
      }
      if (
        Number(this.MabBardasht.replace(/,/g, "")) <=
        this.Resultcmb.ghabelBardasht + this.Resultcmb.sumMabTaeedNaShode
      ) {
        var NameSahebHesab =
          this.$session.get("CustCode") != 801
            ? this.NameSahebHesab
            : this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily;
        if (this.$session.get("CustCode") == 934) {
          this.$SweetQustion(
            "اطمینان از برداشت وجه",
            " از برداشت وجه به مبلغ " +
              this.$Comma3ragham(Number(this.MabBardasht.replace(/,/g, ""))) +
              this.$GetVahedPool() +
              "  به شماره شـــبا یا شماره کــــارت " +
              this.CardNo +
              "  به نام آقا | خانم " +
              NameSahebHesab +
              " اطمینان دارید ؟ ",
            "question",
            "تایید برداشت",
            "انصراف",
            id,
            this.checkSms,
            this.isNotConfirmed,
          );
        } else {
          this.$SweetQustion(
            "اطمینان از برداشت وجه",
            " از برداشت وجه به مبلغ " +
              this.$Comma3ragham(Number(this.MabBardasht.replace(/,/g, ""))) +
              this.$GetVahedPool() +
              "  به شماره شـــبا یا شماره کــــارت " +
              this.CardNo +
              this.ShebaNo +
              "  به نام آقا | خانم " +
              NameSahebHesab +
              " اطمینان دارید ؟ ",
            "question",
            "تایید برداشت",
            "انصراف",
            id,
            this.checkSms,
            this.isNotConfirmed,
          );
        }
      } else {
        this.$mySweetDefaultTost(
          "خطا",
          "مبلغ برداشت نمیتواند بیشتر از مبلغ قابل برداشت باشد حساب باشد",
          "warning",
          2000,
        );
        this.refreshCaptcha();
        return;
      }
    },
    jumpTo(id) {
      document.getElementById(id).focus();
    },
    checkSms() {
      if (this.$session.get("CustCode") == "255") {
        this.sendTwoStepCode();
      } else this.ConfirmBardasht();
    },
    sendTwoStepCode() {
      this.twoLevel = true;
      var DataAxiosSms = {
        Method: "GET",
        Token: this.$session.get("TokenNetPa"),
        Action:
          "twoStepVerification?wwwtblAzaId=" +
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        ArryfildValue: null,
      };
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == "success") {
          this.$mySweetDefaultTost("", result.msg, "success", 2800);
        }
      });
    },
    CheckCode() {
      var DataAxiosCheckCode = {
        Method: "POST",
        Token: this.$session.get("TokenNetPa"),
        Action: "twoStepVerification",
        ArryfildValue: {
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          Code: this.twstepCode + "",
        },
      };
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.ConfirmBardasht();
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید",
            "error",
            2800,
          );
        }
      });
    },
    ConfirmBardasht(id) {
      if (this.SaveShebaOrCard == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "ذخیره اطلاعات شبا و یا کارت با موفقیت انجام گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "ذخیره اطلاعات شبا و یا کارت با خطا روبه رو شد",
              "danger",
              2000,
            );
          }
        });
      }
      this.loadingRender = true;
      var Mablagh = this.MabBardasht.replace(/,/g, "");
      var NameSahebHesab =
        this.$session.get("UserInfoNetPa").ozvName +
        " " +
        this.$session.get("UserInfoNetPa").ozvFamily;
      var ShebaIR = "";
      //console.log('/**/*/*/*/',this.ShebaNo);

      if (
        this.ShebaNo != null &&
        this.ShebaNo != "" &&
        this.ShebaNo != undefined
      ) {
        ShebaIR = "IR" + this.ShebaNo;
        //console.log('/**/*/*/*/',ShebaIR);
      }
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblTaahodatIdBestanKar", 0);
      formData.append("wwwtblTaahodatIdBedehKar", id ? id : this.Resultcmb.id);
      formData.append("Mablagh", Mablagh);
      formData.append(
        "Desc",
        this.Description.trim() == ""
          ? "درخواست برداشت از حساب"
          : " درخواست برداشت : " + this.Description,
      );
      formData.append("KodRahgiri", "");
      formData.append(
        "CardNo",
        this.$session.get("CustCode") != 801 ? this.CardNo : "",
      );
      formData.append(
        "ShebaNo",
        this.$session.get("CustCode") != 801 ? ShebaIR : "",
      );
      formData.append(
        "NameSahebHesab",
        this.$session.get("CustCode") != 801
          ? this.NameSahebHesab
          : NameSahebHesab,
      );
      formData.append("EnteghalNoe", 6);
      formData.append("HesabNo", "");
      formData.append("OrderId", "-2");
      formData.append("MabKarmozdEnteghal", 0);
      formData.append("MabKarmozdBnp", 0);
      formData.append(
        "BankName",
        this.$session.get("CustCode") != 801 ? this.BankName : "",
      );
      formData.append("ComboIdGrp324", "");
      formData.append("TarixSanad", this.$store.state.JalaliDate);
      if (this.NoeEnteghal == "Sheba") {
        // Sheba همان پایا هست
        formData.append("tblcombiId330NoeEnteghal", 7384);
      } else if (this.NoeEnteghal == "Satna") {
        formData.append("tblcombiId330NoeEnteghal", 7385);
      } else {
        formData.append("tblcombiId330NoeEnteghal", 7386);
      }
      formData.append("userInput", this.captchaText);
      formData.append("captchaId", this.captchaId);

      // formData.append('tblBankId', this.tblBankId)
      this.DataAxios.ArryfildValue = formData;

      this.$PostFormData(this.DataAxios).then((data) => {
        if (data.success == "SUCCESS") {
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "درخواست موفقیت آمیز",
            "درخواست برداشت با موفقیت انجام شد،کدرهگیری شما:" +
              data.codeRahgiri,
            "success",
            7000,
          );
          this.loadingRender = false;
          this.$router.push({ name: "DebtorReport" });
          // checkIn
        } else if (data.success == "Failed") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "انتقال ناموفق",
            data.message,
            "warning",
            3000,
          );
          this.refreshCaptcha();
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "خطا",
            "در برداشت از حساب مشکلی پیش آمده لطفا مجددا تلاش کنید",
            "warning",
            2000,
          );
          this.refreshCaptcha();
        }
      });
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          IsSheba: this.NoeEnteghal == "Card" ? false : true,
          SahebShebaOrCard: this.NameSahebHesab,
          ShebaOrCardNum: this.CardNo.length > 0 ? this.CardNo : this.ShebaNo,
          IsBardasht: true,
          IsEstelamOnline: this.ShowEstelam == true ? true : false,
        };
        var DataAxiosFindShebaOrCard = {
          ArryfildValue: Data,
          Method: "Post",
          Action: "ShebaOrCard",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == "Success") {
            success(true);
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        });
      });
    },
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: "",
        Method: "post",
        Action: "ShebaOrCard/GetShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        // console.log('data',data);

        data.forEach((value) => {
          value["select"] = false;
        });

        this.ListCard = data.filter(
          (x) => x.isSheba == false && x.isBardasht == true,
        );
        this.ListSheba = data.filter(
          (x) => x.isSheba == true && x.isBardasht == true,
        );
      });
    },
    SelectShebaOrCard(id, isSheba) {
      if (isSheba) {
        this.ListSheba.forEach((el) => {
          if (el.id == id) {
            el.selected = true;
            this.ShebaNo = el.shebaOrCardNum;
            this.NameSahebHesab = el.sahebShebaOrCard;
            this.ShowEstelam = true;
            this.KEY++;
          } else {
            el.selected = false;
          }
        });
      } else {
        this.ListCard.forEach((el) => {
          if (el.id == id) {
            el.selected = true;
            this.First4Digit = el.shebaOrCardNum.slice(0, 4);
            this.Second4Digit = el.shebaOrCardNum.slice(4, 8);
            this.Third4Digit = el.shebaOrCardNum.slice(8, 12);
            this.Forth4Digit = el.shebaOrCardNum.slice(12, 16);
            this.NameSahebHesab = el.sahebShebaOrCard;
            this.KEY++;
            this.EstelamCart();
            this.checkBankName();
          } else {
            el.selected = false;
          }
        });
      }
      this.ShowList = false;
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion(
        "اطمینان ازحذف",
        " از حذف شماره شبا و یا شماره کارت " +
          row.shebaOrCardNum +
          " به نام  " +
          row.sahebShebaOrCard +
          " اطمینان دارید ؟ ",
        "question",
        "تایید حذف",
        "انصراف",
        row.id,
        this.ConfirmRemoveShebaOrCard,
        this.isNotConfirmed,
      );
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ShebaOrCard/DeleteShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtbShebaOrCardId", id);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == "Success") {
          this.GetDataShebaOrCard();
          this.KEY++;
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد",
            "success",
            2000,
          );
        }
      });
    },
    isNotConfirmed() {},
    Estelam() {
      this.loadingRender = true;

      var data = {
        CustCode: this.$session.get("CustCode"),
        Sign: "",
        IbanNumber: "IR" + this.ShebaNo,
      };
      var EstelamAxios = {
        action: "EstelamSheba/Index",
        method: "POST",
        arryfildValue: data,
      };

      this.$PostData_netpatoken(EstelamAxios)
        .then((result) => {
          console.log("/*/*/*/*/*/", result);

          if (typeof result == "string" || result.isSuccess == false) {
            var message = result == "string" ? result : result.message;
            this.$mySweetDefault("خطا", message, "error", 2000);
          } else {
            this.EstelamData.accountNumber = result.accountNumber;
            this.EstelamData.holders = result.ibanAccountOwnerList;
            this.EstelamData.accountComment = result.accountComment;
            this.EstelamData.bankCode = result.bankCode;
            this.EstelamData.bankName = result.bankName;
            this.BankName = result.bankName;
            this.ShowEstelam = true;
            this.ShowList = false;
            this.NameSahebHesab = "";
            this.EstelamData.holders.forEach((person) => {
              this.NameSahebHesab =
                this.NameSahebHesab + person.firstName + " " + person.lastName;
              this.SaveShebaOrCard = true;
            });
          }
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    getSelectedBank(data) {
      this.tblBankId = data.bnpcashDbId;
    },
    checkBankName() {
      if (
        this.$session.get("CustCode") == 934 ||
        this.$session.get("CustCode") == 8002
      ) {
        let cart = "";
        let Bnk;
        if (this.Second4Digit.length == 2) {
          cart = this.First4Digit + "-" + this.Second4Digit;
          Bnk = this.listBank.find((x) => x.code == cart);
          if (Bnk != undefined) {
            this.isLicenseDebtor = true;
            this.bankSelected = Bnk;
            document
              .querySelector("#Bank")
              .classList.replace("d-none", "d-block");
            document
              .querySelector("#BankName")
              .classList.replace("d-none", "d-block");
            document
              .querySelector("#Error")
              .classList.replace("d-block", "d-none");
            document.querySelector("#BankName").classList.add("BankName");
          } else {
            this.isLicenseDebtor = false;
            document
              .querySelector("#Error")
              .classList.replace("d-none", "d-block");
          }
        } else if (this.Second4Digit.length < 2) {
          this.isLicenseDebtor = false;
          document
            .querySelector("#Bank")
            .classList.replace("d-block", "d-none");
          document
            .querySelector("#BankName")
            .classList.replace("d-block", "d-none");
          document
            .querySelector("#Error")
            .classList.replace("d-block", "d-none");
          document.querySelector("#BankName").classList.remove("BankName");
        }
      }
    },
    EstelamCart() {
      // jumpTo('NameSahebHesab')
      if (
        this.$session.get("CustCode") == 934 ||
        (this.$session.get("CustCode") == 8002 && this.isLicenseDebtor == true)
      ) {
        this.CardNo =
          this.First4Digit +
          this.Second4Digit +
          this.Third4Digit +
          this.Forth4Digit;
        if (this.CardNo.length == 16) {
          this.loadingRender = true;
          let data = {
            BnpInfo: {
              CustCode: this.$session.get("CustCode"),
              BankId: "",
              ClientId: "",
              ClientSecret: "",
            },
            bank: "",
            nationalCode: "",
            sourceAccount: "",
            cardNumber: this.CardNo,
          };
          var EstelamAxios = {
            action: "EnteghalVajh/EstelamCartNumber",
            method: "POST",
            arryfildValue: data,
          };
          this.$PostData_netpatoken(EstelamAxios).then((res) => {
            // console.log(res);

            this.loadingRender = false;
            if (res && res.status == true) {
              this.disable = true;
              this.NameSahebHesab = res.data.respObject.ownerName;
              this.BankName = "BSP";
              this.ShebaNo = res.data.respObject.iban.replace(/IR/g, "");
              this.$mySweetDefault(
                "استعلام موفق",
                "استعلام شماره کارت با موفقیت انجام شد",
                "success",
                2500,
              );
            } else {
              this.isLicenseDebtor = false;
              this.First4Digit = "";
              this.Second4Digit = "";
              this.Third4Digit = "";
              this.Forth4Digit = "";
              this.$mySweetDefault(
                "خطا",
                "خطایی در استعلام شماره کارت رخ داد لطفا  دقایق دیگر امتحان کنید",
                "error",
                2500,
              );
              return;
            }
          });
        } else {
          this.isLicenseDebtor = false;
          this.First4Digit = "";
          this.Second4Digit = "";
          this.Third4Digit = "";
          this.Forth4Digit = "";
          this.$mySweetDefault("خطا", "شماره کارت صحیح نمیباشد", "error", 2500);
          return;
        }
      } else {
        this.jumpTo("NameSahebHesab");
      }
    },
  },
  mounted() {
    if (
      this.$session.get("CustCode") == 561 ||
      this.$session.get("CustCode") == 866 ||
      this.$session.get("CustCode") == 948 ||
      this.$session.get("CustCode") == 953
    ) {
      this.NoeEnteghal = "Sheba";
    } else if (this.$session.get("CustCode") == 934) {
      this.NoeEnteghal = "Card";
    }

    // this.$refs.txtMablagh.focus()
    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append("wwwtblSarfaslTypeId", 2);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6);
        this.Resultcmb = data[0];
        this.Resultcmb = -1;
        this.withdrawalIfLoanIsDelayed =
          this.Resultcmb.withdrawalIfLoanIsDelayed;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          }
          if (this.TaahodatId) {
            this.ListModel.forEach((e) => {
              if (e.id == this.TaahodatId) {
                this.Resultcmb = e;
              }
            });
          }
        });
      });
  },
  created() {},
};
</script>
<style scoped>
.Debtor-form-vertical {
  max-width: 600px;
  margin: 0 auto;
}
.Debtor-section {
  margin-bottom: 1.75rem;
}
.Debtor-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.75rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #dee2e6;
}
.Debtor-field {
  margin-bottom: 1rem;
}
.Debtor-field:last-child {
  margin-bottom: 0;
}
.Debtor-label {
  display: block;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.35rem;
}

.BankName {
  padding-bottom: 1%;
  padding-top: 1%;
  border: 1px dashed chocolate;
  border-radius: 5px;
  background: rgb(241, 231, 224);
  color: chocolate;
  text-align: center;
  font-weight: bold;
}
.BoxList {
  max-height: 30vh !important;
  overflow-y: scroll;
}
.Debtor-sheba-item.border-Sheba {
  border: 2px dashed #435ebe !important;
  border-radius: 8px;
  box-sizing: border-box;
}
.border-Sheba {
  border: 2px dashed #435ebe !important;
  border-radius: 8px;
  box-sizing: border-box;
}
.card {
  border-radius: 15px !important;
}
.radio {
  padding: 4px;
  text-align: center;
  position: relative;
  display: inline;
}

.radio input {
  width: auto;
  height: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 4px 8px;
  color: #bdbdbdbd;
  font-size: 14px;
  transition: all 100ms linear;
}

.radio input {
  color: #000 !important;
  background-image: linear-gradient(180deg, #bdc3db, #a3a4aa);
}
.radio input:checked {
  background-image: linear-gradient(180deg, #435ebe, #5770c9);
  color: #fff !important;
  box-shadow: 0 1px 1px #0000002e;
  text-shadow: 0 1px 0px #79485f7a;
}

.radio input:before {
  content: attr(label);
  display: inline-block;
  text-align: center;
  width: 100%;
}
.btn-ListCard {
  background-image: linear-gradient(180deg, #435ebe, #5770c9);

  color: #fff !important;
  box-shadow: 0 1px 1px #0000002e;
  text-shadow: 0 1px 0px #79485f7a;
}
</style>
